import React from "react";
import { Container } from "react-bootstrap";
const PortalFooter = () => {
    return (
        <React.Fragment>
            <footer className="bg-light border-top fixed-bottom py-1">
                <Container fluid>
                    &copy; Instalasi SIMRS RSABHK - 2023
                </Container>
            </footer>
        </React.Fragment>
    );
}
export default PortalFooter;